import React from "react";
import { Navigate } from "react-router-dom";

const PartnerHomePage = () => {
  return <Navigate replace={true} to="/partner/drivers" />;
};

export default PartnerHomePage;
